import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Caption } from '@/components/@IntranetLibrary/Typography';
import { SUBJECT_MAX_LENGTH } from '@/constant/approval';
import { FieldBlock, FieldHeader, SubjectTextField } from './styles';
import type { ApprovalFormValues } from './types';
import { InfoSectionTitle } from '@/components/Approval/@components/InfoSection';

const SubjectField = () => {
  const { t } = useTranslation();
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<ApprovalFormValues>();
  const subject = watch('subject');

  return (
    <FieldBlock>
      <FieldHeader>
        <InfoSectionTitle>{t('제목')}</InfoSectionTitle>
        {/* Caption 기본 lh 18px — 카운터만 20px 지정(PORTAL-13610) */}
        <Caption sx={{ lineHeight: '20px' }}>
          ({subject.length}/{SUBJECT_MAX_LENGTH})
        </Caption>
      </FieldHeader>
      <SubjectTextField
        fullWidth
        size="small"
        placeholder={t('제목을 입력하세요.')}
        {...register('subject', {
          required: t('결재 제목을 반드시 입력하셔야 합니다.'),
          maxLength: SUBJECT_MAX_LENGTH,
          onChange: (e) => {
            const value: string = e.target.value;
            if (value.length > SUBJECT_MAX_LENGTH) {
              setValue('subject', value.slice(0, SUBJECT_MAX_LENGTH));
            }
          },
        })}
        inputProps={{ maxLength: SUBJECT_MAX_LENGTH }}
        error={!!errors.subject}
        helperText={errors.subject?.message as string}
      />
    </FieldBlock>
  );
};

export default SubjectField;
